import {
  EvidenceTable,
  EvidenceTableHandle,
  EvidenceTableStateKeys,
  GetEvidenceQuery,
} from "@/Features";
import { usePermissions } from "@/hooks/usePermissions";
import {
  Button,
  Divider,
  styled,
  useTheme,
} from "@monolith-forensics/monolith-ui";
import { MonitorSmartphoneIcon } from "lucide-react";
import { useRef, useState } from "react";

enum View {
  ALL = "all",
  CASE = "case",
  MY = "my",
}

const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  flex: 1 1 auto;
`;

const StyledPageHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;

const StyledPageTitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  width: fit-content;
  padding: 2px 4px;
  font-weight: bold;
  font-size: 1rem;
`;

const ViewButton = styled(Button)<{ $active: boolean }>`
  font-weight: 525;

  &,
  & > * {
    opacity: ${({ $active }) => ($active ? 1 : 0.85)} !important;
    text-decoration: none !important;
  }
`;

export const EvidencePage: React.FC<{}> = ({}) => {
  const { currentUser, hasPermission, MONOLITH_PERMISSIONS } = usePermissions();
  const theme = useTheme();
  const [view, setView] = useState<View>(
    hasPermission(MONOLITH_PERMISSIONS.EVIDENCE_READ_ALL) ? View.ALL : View.CASE
  );
  const tableRef = useRef<EvidenceTableHandle>();
  const query: GetEvidenceQuery = {
    assigned_user_id: view === View.MY ? currentUser?.user_id : undefined,
    user_id: view === View.CASE ? currentUser?.user_id : undefined,
  };

  const handleViewChange = (view: View) => {
    tableRef.current?.clearSelections?.();
    setView(view);
    //   localStorage.setItem("evidenceView", view);
  };

  return (
    <StyledPage>
      <StyledPageHeader>
        <StyledPageTitle>
          <MonitorSmartphoneIcon color={theme.palette.primary.main} size={18} />{" "}
          <span>Evidence</span>
        </StyledPageTitle>
        {hasPermission(MONOLITH_PERMISSIONS.EVIDENCE_READ_ALL) && (
          <ViewButton
            variant={view === View.ALL ? "contained" : "outlined"}
            size="xxs"
            $active={view === View.ALL}
            onClick={() => handleViewChange(View.ALL)}
          >
            All
          </ViewButton>
        )}
        <ViewButton
          variant={view === View.CASE ? "contained" : "outlined"}
          size="xxs"
          $active={view === View.CASE}
          onClick={() => handleViewChange(View.CASE)}
        >
          My Cases
        </ViewButton>
        <ViewButton
          variant={view === View.MY ? "contained" : "outlined"}
          size="xxs"
          $active={view === View.MY}
          onClick={() => handleViewChange(View.MY)}
        >
          Assigned to Me
        </ViewButton>
      </StyledPageHeader>
      <Divider style={{ marginBottom: 10, marginTop: 5, opacity: 0.5 }} />
      <EvidenceTable
        tableRef={tableRef}
        query={query}
        stateStoreKey={EvidenceTableStateKeys.MAIN_EVIDENCE_TABLE}
      />
    </StyledPage>
  );
};
